import { Box, Button, Card, CardContent, Grid, InputLabel, TextField, Typography,Dialog, Snackbar, Alert} from '@mui/material';
import AdminWrapper from 'csam/admin/components/AdminWrapper';
import { getGraphClient } from 'csam/admin/pages/phishing-emails/getGraphClient';
import React, { useContext, useState, useRef } from 'react';
import 'react-quill/dist/quill.snow.css';
import { useMsal } from '@azure/msal-react';
import EmailInputWithTags from '../phishing-emails/EmailInputWithTags';
import { useAuthenticatedQuery, useAuthenticatedMutation } from 'csam/api/api';
import { fixed, getImage } from 'src/utils/Constants';
import LocaleContext from 'csam/components/LocaleContext';
import AdminPageLoader from 'csam/admin/components/AdminPageLoader';
import AdminInternalError from '../AdminInternalError';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';

interface EmailState {
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  body: string;
  additionalData: Object | { [key: string]: string }[];
  excelFile: File | null;
}

interface EmailTemplateData {
  id: number;
  template_title: string;
  email_subject: string;
  email_body: string;
  created_at: string;
  status: number;
}

interface TemplateResponse {
  success: boolean;
   data: EmailTemplateData[];
}

const AppsecEmail = () => {
  const { instance, accounts } = useMsal();

  const [emailContent, setEmailContent] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<string | null>(null);
  const { locale } = useContext(LocaleContext);
  const [openResultModal, setOpenResultModal] = useState(false);
const [resultMessage, setResultMessage] = useState('');
const [resultType, setResultType] = useState<'success' | 'error'>('success');

  const primaryEmail = 'Security_Compliance_Awareness@ab-inbev.com';
  const secondaryEmail = 'GISP_Support@ab-inbev.com';

  const uploadImageMutation = useAuthenticatedMutation(['upload-phishing-image', 'POST'], (formData: FormData) => ({
    url: `https://react-cybersecurityandcompliance-awareness.ab-inbev.com/api/pemail/upload-image`,
    method: 'POST',
    data: formData,
  }));
  const localeFromStorage = localStorage.getItem('locale') || 'en';
  const { isPending, error, data } = useAuthenticatedQuery<TemplateResponse>([locale], {
    url: `${fixed}admin/${locale || localeFromStorage}/email_templates`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  const reminderMutation = useAuthenticatedMutation(
  ['send-reminder', 'POST'],
  () => ({
    url: `${fixed}admin/send-reminder-emails`, // replace with your actual route
    method: 'POST',
  })
);

  const styles = {
    quillContainer: {
      minHeight: '300px', // or height: '300px'
      backgroundColor: 'white',
      color: 'black',
      border: '1px solid #ccc',
    },
    toolbar: {
      backgroundColor: '#f5f5f5', // Light background for toolbar
      border: '1px solid #ddd', // Light border for toolbar
    },
    editor: {
      backgroundColor: 'white', // Light background for the editor area
      color: 'black', // Text color for editor content
    },
  };

  // const handleTemplateSelect = (templateId: string) => {
  //   setSelectedTemplate(templateId);
  // };

  const [fromEmails, setFromEmails] = useState<string[]>([primaryEmail]);
  const [email, setEmail] = useState<EmailState>({
    to: [],
    cc: [],
    bcc: [],
    subject: '',
    body: '',
    additionalData: [],
    excelFile: null,
  });

  const [_emailInput, setEmailInput] = useState('');

  const encodeHTML = (str: string) => {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const sendEmailMutation = useAuthenticatedMutation(['send-email-excel', 'POST'], (formData: FormData) => ({
    url: `https://react-cybersecurityandcompliance-awareness.ab-inbev.com/api/email/send-appsec-email`,
    method: 'POST',
    data: formData, // same as your uploadImageMutation
  }));

  const handleSendEmailToBackend = async () => {
    if (!email.to.length) {
      toast.error('No recipients found. Upload an Excel file first.');
      return;
    }
    
    
    
    const formData = new FormData();

    // Append additional fields to the formData
   

    // Handle Excel data - this is where we make sure the file is attached
    const excelFile = email.excelFile; // This assumes you've set email.excelFile after file upload
    if (excelFile) {
      formData.append('file', excelFile);
    } else {
      toast.error('Please upload an Excel file first!');
      return;
    }

    // If you want to send additional data (like to, cc, bcc etc.)
    const excelData = email.to.map((to, i) => ({
      to,
      cc: email.cc.filter((_, idx) => idx === i),
      bcc: email.bcc.filter((_, idx) => idx === i),
      additionalData: email.additionalData[i],
    }));

    // Append the JSON stringified excel data (the actual content)
    formData.append('emails', JSON.stringify(excelData));

    // Now send the request
    try {
      const res = await sendEmailMutation.mutateAsync(formData);

      if (res.success) {
    setResultType('success');
    setResultMessage('Emails sent successfully');
} else {
    setResultType('error');
    setResultMessage(res.message || 'Failed to send emails');
}
setOpenResultModal(true);
    } catch (err) {
      setResultType('error');
setResultMessage('Error sending emails');
setOpenResultModal(true);
    }
  };

  const handleSendReminder = async () => {
  try {
    const res = await reminderMutation.mutateAsync({});

    setResultType(res.success ? 'success' : 'error');
    setResultMessage(res.message || 'Reminder processed');
    setOpenResultModal(true);
  } catch (err) {
    setResultType('error');
    setResultMessage('Reminder failed');
    setOpenResultModal(true);
  }
};



  const handleUploadExcel = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = event.target?.result;
      if (!data) return;

      const workbook = XLSX.read(data, { type: 'binary' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      // 👇 this is the new version that matches your Excel: to, cc, bcc
      setEmail((prev) => ({
        ...prev,
        to: jsonData.map((row) => row.to || ''),
        cc: jsonData
          .map((row) =>
            row.cc
              ? row.cc
                  .split(/[ ,;]/)
                  .map((x: string) => x.trim())
                  .filter(Boolean)
              : [],
          )
          .flat(),
        bcc: jsonData
          .map((row) =>
            row.bcc
              ? row.bcc
                  .split(/[ ,;]/)
                  .map((x: string) => x.trim())
                  .filter(Boolean)
              : [],
          )
          .flat(),
        additionalData: jsonData,
        excelFile: file,
      }));
    };

    reader.readAsBinaryString(file);
  };

  if (isPending) return <AdminPageLoader />;
  if (error) return <div>Error: {error.message}</div>;
  if (data && !data.success) return <AdminInternalError />;
  const templates = data.data || [];

  return (
    <AdminWrapper>
      <Box className="pageHeader">
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Typography variant="h6"> Assign AppSec Training </Typography>
        </Box>
      </Box>

      <Box>
        <Box className="form-group" mb={4}>
          <InputLabel>Upload User List (Excel)</InputLabel>
          <TextField
            type="file"
            name="file"
            onChange={handleUploadExcel}
            fullWidth
            inputProps={{ accept: '.xlsx,.csv' }}
          />
        </Box>

       <Snackbar
  open={openResultModal}
  autoHideDuration={600000} // disappears after 4s
  onClose={() => setOpenResultModal(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert
    severity={resultType === 'success' ? 'success' : 'error'}
    onClose={() => setOpenResultModal(false)}
    sx={{
      minWidth: 320,
      backgroundColor: '#424242', // dark grey
      color: '#fff',
      boxShadow: 6,
    }}
  >
    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
      {resultType === 'success' ? 'Success' : 'Failed'}
    </Typography>
    <Typography variant="body2">{resultMessage}</Typography>
  </Alert>
</Snackbar>




        <Button variant="contained" color="primary" onClick={handleSendEmailToBackend}>
          Send Email
        </Button>

         {/* <Button variant="contained" color="primary" onClick={handleSendReminder}>
          Send Appsec  Notification email
        </Button> */}
      </Box>

      
    </AdminWrapper>
  );
};

export default AppsecEmail;
